<template>
  <div
    :class="computedClasses"
  >
    <tr-typography
      classes="no-padding"
      variant="h3"
      :strong="true"
    >
      {{ initials }}
    </tr-typography>
  </div>
</template>

<script>
import TrTypography from './TrTypography.vue';

const DEFAULT_COLOR = 'blue';

export default {
  name: 'TrAvatar',
  components: {
    TrTypography
  },
  props: {
    color: {
      required: false,
      type: String,
      default: ''
    },
    text: {
      required: false,
      type: String,
      default: ''
    },
    isOutlined: {
      required: false,
      type: Boolean,
      default: false
    },
    size: {
      required: false,
      type: String,
      default: ''
    },
    textColor: {
      required: false,
      type: String,
      default: ''
    }
  },
  computed: {
    initials() {
      return this._getInitials();
    },
    computedClasses() {
      let classes = 'avatar img-circle center-h-and-v';

      if (this.isOutlined) {
        classes += ` ic--white border--${this.color || DEFAULT_COLOR} border--solid `;
      } else {
        classes += ` ic--blue bg-${this.color || DEFAULT_COLOR} `;
      }

      classes += ` ic--${this.size || 'medium'} `;

      classes += ` ${this.textColor || 'black'} `;

      return classes;
    }
  },
  methods: {
    _getInitials() {
      if (this.text && typeof this.text === 'string' && this.text.length > 2) {
        const names = this.text.split(' ');
        let initials = names[0].substring(0, 1).toUpperCase();

        if (names.length > 1) {
          initials += names[names.length - 1].substring(0, 1).toUpperCase();
        }
        return initials;
      }
      return this.text;
    }
  }
};

</script>
